import { isEmpty } from 'lodash'
import { Params, useQueryWithParams } from 'hooks/useQueryWithParams'
import { GET_USERS } from 'queries/users'
import { findAllUsers, findAllUsersVariables } from '__generatedTypes__/findAllUsers'
import { SearchTypeEnum } from '__generatedTypes__/globalTypes'
import { getFilterParams, Filters } from './utils'

export function castParams({ page, take, search, filters, order }: Params<Filters>): findAllUsersVariables {
  const where = getFilterParams(filters)

  return {
    query: {
      search: {
        query: search,
        type: SearchTypeEnum.ILike,
      },
      skip: (page - 1) * take,
      take,
      order:
        order && filters.selectedPlatform
          ? {
              [order.field]: order.direction,
            }
          : undefined,
      where: !isEmpty(where) ? where : undefined,
    },
  }
}

export function useUsers() {
  return useQueryWithParams<findAllUsers, findAllUsersVariables, 'findAllUsers', 'items', 'count', Filters>(
    GET_USERS,
    'findAllUsers',
    'items',
    'count',
    castParams,
    undefined,
    {
      fetchPolicy: 'network-only',
    }
  )
}
